export interface InputErrors {
	badInput?: string,
	customError?: string,
	patternMismatch?: string,
	rangeOverflow?: string,
	rangeUnderflow?: string,
	stepMismatch?: string,
	tooLong?: string,
	tooShort?: string,
	typeMismatch?: string,
	valid?: string,
	valueMissing?: string,
	exampleValidInput?: string
}

const defaultErrors = {
	badInput: 'is a bad input',
	patternMismatch: 'format incorrect',
	rangeOverflow: 'too high',
	rangeUnderflow: 'too low',
	stepMismatch: 'does not match the step',
	tooLong: 'too long',
	tooShort: 'too short',
	typeMismatch: 'format incorrect',
	valueMissing: 'required',
	customError: 'invalid',
}

export const makeErrors = (_options: InputErrors = {}) => {
	const options = {...defaultErrors, ..._options}

	return (field: HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement, _name = '') => {
		const {name: defaultName, validity, value} = field
		const {placeholder, minLength, maxLength} = field as (HTMLInputElement|HTMLTextAreaElement)

		const name = placeholder?.replace('*', '') || _name || defaultName

		// find the first error
		const errorKey = Object.keys(options).find(key => validity[key] ? key : false)

		if (errorKey && options[errorKey]) {
			if (typeof options[errorKey] === 'function') {
				return options[errorKey]({error: errorKey, value})
			}

			if (errorKey === 'patternMismatch' && options.exampleValidInput) {
				return `${name} ${options[errorKey]} ${options.exampleValidInput}`
			}

			if (errorKey === 'tooShort' && minLength) {
				return `${name} should be atleast ${minLength} characters`
			}

			if (errorKey === 'tooLong' && maxLength) {
				return `${name} cannot be more than ${maxLength} characters`
			}

			return `${name} ${options[errorKey]}`
		}
	}
}
